import React         from 'react';
import Utils         from 'utils';
// -------------------------------------------------------

class ContentsModal extends React.Component {
  UNSAFE_componentWillReceiveProps(nextProps){
    setTimeout( function(){
      let items = document.getElementsByClassName('contents-modal-existence-flg');
      if( items.length == 0 ){
        Utils.unlockFixedContents();
      } else {
        Utils.fixedContents();
      }
    }.bind(this), 50);
  }
  // -------------------------------------------------------
  
  render() {
    if( this.props.view == false ) return null;
    
    let width  = (this.props.width  == undefined) ? 500 : this.props.width;
    let height = (this.props.height == undefined) ? 500 : this.props.height;
    let max_width = this.props.max_width;
    
    let left  = (this.props.left != undefined && this.props.left != null) ? this.props.left : undefined;
    let right = (this.props.left != undefined && this.props.left != null) ? 'auto' : undefined;
    
    // サブローディング処理;
    try {
      return (
        <div className="contents-modal contents-modal-existence-flg">
          { (this.props.close_ev != undefined)
            ? <div className="contents-modal-bg" onClick={this.props.close_ev.bind(this, false)} />
            : <div className="contents-modal-bg" />
          }
          <div className="contents-modal-box" style={{ width: width, height: height, maxWidth: max_width, left: left, right: right }}>
            { (this.props.close_ev != undefined)
              ? <div className="close" onClick={this.props.close_ev.bind(this, false)}>×</div>
              : null
            }
            
            {this.props.html}
          </div>
        </div>
      );
    } catch(e) {
      return (
        <div className="contents-modal contents-modal-existence-flg">
          { (this.props.close_ev != undefined)
            ? <div className="contents-modal-bg" onClick={this.props.close_ev.bind(this, false)} />
            : <div className="contents-modal-bg" />
          }
          <div className="contents-modal-box" style={{ width: width, height: height, maxWidth: max_width, left: left, right: right }}>
            { (this.props.close_ev != undefined)
              ? <div className="close" onClick={this.props.close_ev.bind(this, false)}>×</div>
              : null
            }
            <p>ERROR</p>
          </div>
        </div>
      );
    }
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ContentsModal;